// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__qYOr8","row":"ProcedureTreatmentSummary_row__LBA9N"};